
export default {
  name: 'AppExternalLink',
  props: {
    to: {
      type: String,
      default: null
    }
  }
};
